module.exports = __webpack_public_path__ + "static/media/sjokolade.af89b6c7.mp3";